/**
 * Citizens Information Brand Configuration
 * 
 * Brand-specific settings for the AskCI Admin application
 * when running under the Citizens Information brand.
 */

export const citizensInfoBrandConfig = {
  // Application branding
  appName: 'AskCI Admin',
  appTitle: 'AskCI Admin - Citizens Information',
  appDescription: 'Administrative dashboard for Citizens Information knowledge management',
  
  // Header configuration
  header: {
    showLogo: true,
    logoVariant: 'full' as const,
    showAppName: true,
    showUserProfile: true,
    navigationStyle: 'modern' as const, // 'government' | 'modern' | 'minimal'
  },
  
  // Color scheme
  colors: {
    primary: '#0085CA',
    secondary: '#84BD00',
    accent: '#E30000',
    header: {
      background: 'var(--header-bg)',
      text: 'var(--header-text)',
      brandBackground: 'var(--header-brand-bg)',
      brandText: 'var(--header-brand-text)',
    }
  },
  
  // Design system
  design: {
    borderRadius: 'rounded', // 'sharp' | 'rounded' | 'mixed'
    borderStyle: 'soft', // 'angular' | 'soft' | 'mixed'
    shadowStyle: 'subtle', // 'subtle' | 'prominent' | 'minimal'
    typography: 'modern', // 'government' | 'modern' | 'classic'
  },
  
  // Layout preferences
  layout: {
    headerHeight: '64px',
    sidebarWidth: '240px',
    contentPadding: 'var(--space-6)',
    cardSpacing: 'var(--space-4)',
  },
  
  // Feature flags
  features: {
    enableAdvancedAnalytics: true,
    enableMultiLanguage: false,
    enableGovernmentCompliance: false,
    enableAuditLogging: false,
  },
  
  // Citizens Information-specific settings
  citizensInfo: {
    complianceMode: false,
    auditRequired: false,
    dataRetention: '3years',
    accessibilityLevel: 'WCAG-AA',
  }
} as const;

export type CitizensInfoBrandConfig = typeof citizensInfoBrandConfig;
